/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useMailTemplates = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.MAIL_TEMPLATES,
    queryFn: async () => API.getInstance().getMailTemplateList().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const mailTemplateOptions = React.useMemo(
    () => data?.map((option) => ({ label: option, value: option })) || [],
    [data],
  );

  return {
    mailTemplatesLoading: isLoading,
    mailTemplateOptions,
    data,
    error,
    fetchStatuses: refetch,
  };
};

export {
  useMailTemplates,
};
